import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DomainsModalComponent} from './domains-modal.component';
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {FormsModule} from "@angular/forms";
import { ButtonModule } from '@xref/xref-lib';
import {LoaderModule} from "../loader/loader.module";


@NgModule({
  declarations: [DomainsModalComponent],
  imports: [
    CommonModule, FormsModule,
    AlertMessageModule,
    ButtonModule,
    LoaderModule
  ],
  exports: [DomainsModalComponent]
})
export class DomainsModalModule { }
